import React, { Component } from "react";
import countryCodes from "../../../public/static/country.codes.json";
import getParsedPhone from "../../lib/getParsedPhone";

class PhoneInput extends Component {
  constructor(props) {
    super(props);
    const { defaultNumber } = props;
    let countryCode = "gb",
      countryDialCode = "+44",
      mobileNumber = "";
    if (defaultNumber) {
      const parsedPhone = getParsedPhone(defaultNumber);
      countryCode = parsedPhone.countryCode;
      countryDialCode = parsedPhone.countryDialCode;
      mobileNumber = parsedPhone.mobileNumber;
    }

    this.state = {
      countryCode,
      countryDialCode,
      mobileNumber,
      error: "Mobile number is not valid",
      listVisible: false
    };
  }
  onChange = (countryCode, countryDialCode) => {
    this.setState(
      {
        countryCode,
        countryDialCode
      },
      () => {
        const { mobileNumber } = this.state;
        const e = {
          target: {
            value: mobileNumber
          }
        };
        this.handleChange(e);
      }
    );
  };
  handleChange = event => {
    this.setState(
      {
        mobileNumber: event.target.value
      },
      () => {
        const { countryDialCode, mobileNumber } = this.state;
        const { submitPhoneNumber } = this.props;
        const nonZeroStart = mobileNumber.replace(/^0+/, "");
        const completedNumber = countryDialCode + nonZeroStart;
        if (nonZeroStart.length && nonZeroStart.length > 7) {
          this.setState({ error: "" }, () => {
            submitPhoneNumber(completedNumber);
          });
        } else {
          this.setState(
            {
              error: "Phone number is not valid"
            },
            () => {
              const { error } = this.state;
              submitPhoneNumber(completedNumber, error);
            }
          );
        }
      }
    );
  };
  showError = () => {
    const { showErrors } = this.props;
    return typeof showErrors === "boolean" ? showErrors : true;
  };
  show = () => {
    this.setState({ listVisible: true });
    document.addEventListener("click", this.hide);
  };

  hide = () => {
    this.setState({ listVisible: false });
    document.removeEventListener("click", this.hide);
  };
  renderListItems = () => {
    return countryCodes.map(country => {
      return (
        <div
          key={country.code}
          id={country.dial_code}
          className="p-15"
          onClick={() =>
            this.onChange(country.code.toLowerCase(), country.dial_code)
          }
        >
          <span>
            {country.name} - {country.dial_code}
          </span>
        </div>
      );
    });
  };
  onClickSmsVerified = e => {
    const { sendSmsVerificationKey, smsVerified } = this.props;
    if (smsVerified) {
      e.preventDefault();
    } else {
      sendSmsVerificationKey();
    }
  };
  render() {
    const {
      countryCode,
      countryDialCode,
      error,
      mobileNumber,
      listVisible
    } = this.state;
    const showError = this.showError();
    const { className, label, smsVerified, smsVerification } = this.props;
    return (
      <div
        className={`form-group verified ${className || ""} ${(showError &&
          error &&
          "error") ||
          ""}`}
      >
        <div className="d-flex justify-content-around phone-div">
          <div className={"dropdown-container" + (listVisible ? " show" : "")}>
            <div
              className={"dropdown-display" + (listVisible ? " clicked" : "")}
              onClick={this.show}
            >
              <span id={`select-country-${countryCode}`}>{countryCode}</span>
              <p className="selected-country-code">{countryDialCode}</p>
            </div>
            <div className="dropdown-list">
              <div>{this.renderListItems()}</div>
            </div>
          </div>
          <input
            type="tel"
            className={`form-input ${(label &&
              ((mobileNumber && "active") || "")) ||
              ""}`}
            placeholder="Mobile Phone Number"
            onChange={this.handleChange}
            id="mobileNumber"
            value={mobileNumber}
            onKeyPress={evt => {
              if (
                (evt.which != 8 && evt.which != 0 && evt.which < 48) ||
                evt.which > 57
              ) {
                evt.preventDefault();
              }
            }}
          />
          {label && <label htmlFor="mobileNumber">{label}</label>}
          <a
            href="javascript:void(0)"
            onClick={this.onClickSmsVerified}
            className="verified-div d-flex align-items-center hide-xs"
          >
            {(!smsVerified && !smsVerification && (
              <>
                <label>Not Verified</label>
                <i className="icon icon-arrow-left rotate" />
              </>
            )) || <noscript />}
          </a>
          {(!smsVerified && !smsVerification && (
            <a className="verified-div visible-xs">
              <>
                <label>Not Verified</label>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                  >
                    <g fill="none" fillRule="evenodd">
                      <circle cx="7.5" cy="7.5" r="7.5" fill="#D8D8D8" />
                      <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M6.881 7.5L4.128 4.747a.438.438 0 0 1 .619-.619L7.5 6.881l2.753-2.753a.437.437 0 1 1 .619.619L8.119 7.5l2.753 2.753a.437.437 0 1 1-.619.619L7.5 8.119l-2.753 2.753a.437.437 0 1 1-.619-.619L6.881 7.5z"
                      />
                    </g>
                  </svg>
                </span>
              </>
            </a>
          )) || <noscript />}
        </div>
        <span>{(showError && error && error) || ""}</span>
        {!smsVerified && !smsVerification && (
          <a
            href="javascript:void(0)"
            className="visible-xs verified-button-abs"
            onClick={this.onClickSmsVerified}
          >
            Click here to verify your number
          </a>
        )}
      </div>
    );
  }
}

export default PhoneInput;
